import apiClient from './api-client'

function get() {
  return apiClient.get('dashboard')
}

export default {
  get,
}
